import React from 'react';
import { Link } from 'react-router-dom';
import { Message, Icon } from 'semantic-ui-react';

const ExternalCalendarWarning = () => (
  <Message
    negative
    style={{
      position: 'sticky', top: '0', width: '100%', zIndex: 1000,
    }}
  >
    <Icon name="warning circle" size="large" />
    {'We had trouble connecting to your external calendar(s).'}
    {' Please go to '}
    <Link
      to="/settings/availability/external_calendars"
      style={{ textDecoration: 'underline', color: 'darkred' }}
    >
      Settings
    </Link>
    {' to reconnect your external calendar.'}
  </Message>
);

export default ExternalCalendarWarning;
